module.exports = __webpack_public_path__ + "img/ic-gantt.8c1cc443.svg";